export const paginationEndStyle = {
  fontSize: "12px",
  color: "#807F94",
  "& span": {},
};
